var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-x-widget',{ref:"widget",attrs:{"preview-mode":true,"loading":_vm.loading,"widget-data":_vm.widgetData,"domain-data":_vm.domainData,"google-auth":_vm.googleAuth,"facebook-auth":_vm.facebookAuth,"field-types":_vm.fieldTypes},on:{"update:loading":function($event){_vm.loading=$event},"close":function($event){_vm.setShow = false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }